import React, { useRef, useState } from 'react';
import { Tooltip } from 'reactstrap';
import PropTypes from 'prop-types';

function TooltipIcon({ iconClass, tooltipText }) {
  const [tabTooltipOpen, setTabTooltipOpen] = useState(false);
  const tabTooltipTargetRef = useRef();

  return (
    <>
      <i className={iconClass} ref={tabTooltipTargetRef} />
      <Tooltip
        placement="top"
        isOpen={tabTooltipOpen}
        target={tabTooltipTargetRef}
        toggle={() => setTabTooltipOpen(!tabTooltipOpen)}
      >
        {tooltipText}
      </Tooltip>
    </>
  );
}

TooltipIcon.propTypes = {
  iconClass: PropTypes.string,
  tooltipText: PropTypes.string,
};

TooltipIcon.defaultProps = {
  iconClass: 'fa fa-circle-info',
  tooltipText: undefined,
};

export default TooltipIcon;
